import mapbox from "mapbox-gl";

// https://docs.mapbox.com/help/glossary/access-token/
mapbox.accessToken =
  "pk.eyJ1IjoiZW1tZXR0bWNjYW5uIiwiYSI6ImNrOHl1bW42aTFtMnYzdWpzbXl6c2hhOTAifQ.vZOy44ZEfFIjx2fuW3-C0Q";

const key = {};

export { mapbox, key };
